import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { UserSubscriptionService } from "../../services/userSubscription.service";

export const useGetUserSubscriptionCancellationReasonKeysQuery = () => {
  return useQuery<{ keys: string[] }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_USER_SUBSCRIPTION_CANCELLATION_REASON_KEYS],
    queryFn: () =>
      UserSubscriptionService.getUserSubscriptionCancellationReasonKeys().then((res) => res.data),
  });
};
